import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

filterStyles.toDate = {};
filterStyles.fromDate = {};

filterStyles.fromGridItem = {
    width: [6, 6, 3, 3, 2],
    css: css`
        padding-right: 0;
        > div {
            width: 100%;
        }
    `,
};
filterStyles.toGridItem = {
    width: [6, 6, 3, 3, 2],
    css: css`
        padding-right: 5px;
        > div {
            width: 100%;
        }
    `,
};
